import { GlobalAxios } from "../axios/axios-config";
import { ITasyPhysician } from "../models/tasy-physician";

const PHYSICIAN_ROUTE = process.env.REACT_APP_EXTERNAL + "/api/v1/Physician/";

export const getPhysiciansList = (params?: any) => {
  return GlobalAxios.get<ITasyPhysician[]>(PHYSICIAN_ROUTE + "list", {
    params
  });
};